module.exports = __webpack_public_path__ + "static/img/fuwu.0038d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fuwu.jpg
// module id = WzBa
// module chunks = 2